import {
    faClock,
    faMapMarkerAlt,
    faTags,
    faUpRightAndDownLeftFromCenter
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { capitalizeFirstLetter } from '../../utils/formatText';
import { timeToOffset } from '../../utils/program/position';

export default function ProgramTimeline({
    timeSlots,
    stageHeightPx,
    timelineEvents,
    timeWindow,
    onOpenModal
}) {
    return (
        <div className="program__grid">
            <div className="program__timeline">
                {timeSlots.map(t => (
                    <div
                        key={t}
                        className={`program__timeline-slot ${t.endsWith(':00') ? 'is-labeled' : ''}`}
                    >
                        {t.endsWith(':00') && <span className="program__timeline-time">{t}</span>}
                    </div>
                ))}
            </div>

            {/* Scrollbar rundt stage (for mobil) */}
            <div className="program__grid-body" aria-label="Tidslinje">
                <div className="program__stage" style={{ height: `${stageHeightPx}px` }}>
                    {timelineEvents.map(ev => {
                        const { top, height } = timeToOffset(
                            ev.startTime,
                            ev.endTime,
                            timeWindow.baseMin
                        );

                        const isFullWidth = !!ev.override;

                        const laneCount = isFullWidth ? 1 : ev.laneCount || 1;
                        const laneIndex = isFullWidth ? 0 : ev.laneIndex || 0;

                        const widthPct = isFullWidth ? 100 : 100 / laneCount;
                        const leftPct = isFullWidth ? 0 : laneIndex * widthPct;

                        const zIndex = isFullWidth ? 50 : 10 + laneIndex;

                        const isCompact = ev.durationMinutes <= 60;
                        const isTiny = ev.durationMinutes <= 45;

                        const isNarrow = widthPct <= 34;
                        const showTitleOnly = isTiny && isNarrow;

                        return (
                            <div
                                key={ev.id}
                                className={[
                                    `program__event program__event--${ev.categoryKey}`,
                                    isCompact ? 'is-compact' : '',
                                    isTiny ? 'is-tiny' : '',
                                    showTitleOnly ? 'is-titleonly' : ''
                                ]
                                    .filter(Boolean)
                                    .join(' ')}
                                style={{
                                    top: `${top}px`,
                                    height: `${height}px`,
                                    left: `${leftPct}%`,
                                    width: `${widthPct}%`,
                                    zIndex
                                }}
                                onClick={() => onOpenModal(ev)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') onOpenModal(ev);
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faUpRightAndDownLeftFromCenter}
                                    className="program__event-modal-icon"
                                    size="sm"
                                />

                                <div className="program__event-content">
                                    {showTitleOnly ? (
                                        <div className="program__event-titleonly" title={ev.title}>
                                            {ev.title}
                                        </div>
                                    ) : isCompact || isTiny ? (
                                        <div
                                            className="program__event-inline"
                                            title={`${ev.title} • ${ev.startTime}–${ev.endTime}${ev.location ? ` • ${ev.location}` : ''}`}
                                        >
                                            <span className="program__event-inline-title">
                                                {ev.title}
                                            </span>

                                            <span className="program__event-inline-meta">
                                                <span className="program__event-inline-meta-item">
                                                    <FontAwesomeIcon icon={faClock} size="sm" />
                                                    {ev.startTime}–{ev.endTime}
                                                </span>

                                                {ev.location && (
                                                    <span className="program__event-inline-meta-item">
                                                        <FontAwesomeIcon
                                                            icon={faMapMarkerAlt}
                                                            size="sm"
                                                        />
                                                        {ev.location}
                                                    </span>
                                                )}

                                                <span className="program__event-inline-meta-item">
                                                    <FontAwesomeIcon icon={faTags} size="sm" />
                                                    {capitalizeFirstLetter(ev.type_navn)}
                                                </span>
                                                {ev.description && (
                                                    <button className="program__event-readmore">
                                                        Les mer
                                                    </button>
                                                )}
                                            </span>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="program__event-title">{ev.title}</div>

                                            <div className="program__event-info">
                                                <div className="program__event-info-item">
                                                    <FontAwesomeIcon icon={faClock} size="sm" />
                                                    {ev.startTime}–{ev.endTime}
                                                </div>

                                                {ev.location && (
                                                    <div className="program__event-info-item">
                                                        <FontAwesomeIcon
                                                            icon={faMapMarkerAlt}
                                                            size="sm"
                                                        />
                                                        {ev.location}
                                                    </div>
                                                )}

                                                <span className="program__event-inline-meta-item">
                                                    <FontAwesomeIcon icon={faTags} size="sm" />
                                                    {capitalizeFirstLetter(ev.type_navn)}
                                                </span>
                                            </div>

                                            {ev.description && (
                                                <div className="program__event-description-excerpt">
                                                    <button className="program__event-readmore">
                                                        Les mer
                                                    </button>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
